import React from 'react';
import { Text } from '@gravity-ui/uikit';

import { getPhotoUrl } from '@lib/getPhotoUrl';
import { useClientContext } from '@client/lib/ClientContext';
import { currencyDesignation } from '@client/const';

import { i18n } from '../Publication/Publication.i18n';
import type { IPublicationMiniProps } from './PublicationMini.typings';
import {
    publicationMiniAddressCn,
    publicationMiniImgCn,
    publicationMiniImgContainerCn,
    publicationMiniPriceCn,
    publicationMiniTypeApartmentCn,
} from './PublicationMini.const';

import './PublicationMini.scss';

export const PublicationMini: React.FC<IPublicationMiniProps> = props => {
    const [{ lang }] = useClientContext();
    const { publication } = props;
    const [street, setStreet] = React.useState<string>(publication.street);

    const typeApartment = [
        i18n('studio'),
        i18n('apartment1room'),
        i18n('apartment2room'),
        i18n('apartment3room'),
        i18n('apartment4room'),
        i18n('house'),
    ];

    React.useEffect(() => {
        if (publication.streetNames === undefined) {
            return;
        }

        setStreet(publication.streetNames[`name:${lang}`]);
    }, [lang]);

    return (
        <div>
            {publication.photos && (
                <div className={publicationMiniImgContainerCn}>
                    <img
                        key={publication.photos[0].id}
                        className={publicationMiniImgCn}
                        src={getPhotoUrl(publication.photos[0], 'thumb')}
                        alt=""
                    />
                </div>
            )}
            <div className={publicationMiniTypeApartmentCn}>
                <Text variant="subheader-2">{typeApartment[Number(publication.typeApartment) - 1]}</Text>
            </div>
            <div className={publicationMiniAddressCn}>{street}, {publication.houseNumber}</div>
            <div className={publicationMiniPriceCn}>{publication.price} {currencyDesignation[publication.currency]}</div>
        </div>
    );
};
